module.exports = __webpack_public_path__ + "img/ysgj_035@2x.f576c485.png";